<template>
    <div>
        <h2>{{ step.title }}</h2>
        <p>If you need to leave this page, your answers will be saved for 24 hours.</p>
        <p class="step__notice">
            All fields with an asterisk are required
            <i class="fas fa-asterisk"></i>
        </p>
        <p>Please provide details for your emergency contact.</p>
        <p>
            Your emergency contact is the person that would be informed if we ever need to talk to someone about your care and support – for example if you became ill during the course.
        </p>
        <p>
            We’ll only ever use these details in the event of an emergency and
            will never disclose data to your emergency contact without your
            permission.
        </p>
        <div class="row">
            <div class="col-lg-8">
                <InputText
                    name="contact_name"
                    :required="checkIsRequired('contact_name')"
                    :error="formRef.errors.get('contact_name')"
                    v-model="formRef.contact_name"
                    :is-multiline="false"
                >
                    <template v-slot:question>
                        {{ getField("contact_name").question }}
                    </template>
                </InputText>
                <InputText
                    name="contact_mobile_number"
                    :required="checkIsRequired('contact_mobile_number')"
                    :error="formRef.errors.get('contact_mobile_number')"
                    v-model="formRef.contact_mobile_number"
                    :is-multiline="false"
                >
                    <template v-slot:question>
                        {{ getField("contact_mobile_number").question }}
                    </template>
                </InputText>
                <InputRadioGroupVar
                    name="next_of_kin_relation"
                    :required="checkIsRequired('next_of_kin_relation')"
                    :error="formRef.errors.get('next_of_kin_relation')"
                    v-model="formRef.next_of_kin_relation"
                    v-model:other-text="formRef.other_relation_text"
                    :options="getField('next_of_kin_relation')['options']"
                    :form="formRef"
                    @input="formRef.errors.clear('next_of_kin_relation')"
                  >
                    <template v-slot:question>
                        {{ getField("next_of_kin_relation").question }}
                    </template>
                </InputRadioGroupVar>
            </div>
        </div>
    </div>
</template>

<script setup>
import InputRadioGroup from "../../../Form/InputRadioGroup";
import InputText from "../../../Form/InputText";
import Form from "../../../../Form";
import { isRequired } from "./formHelper.js";
import { ref, shallowRef, markRaw } from "vue";

const props = defineProps({
    step: Object,
    fields: Object,
    formData: Object
})

const InputRadioGroupVar = shallowRef(InputRadioGroup)

let formRef = markRaw(ref(new Form({
    contact_name: null,
    contact_mobile_number: null,
    next_of_kin_relation: null,
    other_relation_text: null
}, props.formData)))

const getField = (fieldName) => {
    return props.fields[fieldName];
}

const checkIsRequired = (fieldName) => {
    var fieldData = getField(fieldName);
    return isRequired(fieldData, formRef.value);
}

defineExpose({
  formRef
})
</script>